<title data-tid-alert-title mat-dialog-title>{{ dialogData.title }}</title>
<div mat-dialog-content>
  {{ dialogData.message }}
</div>
<div mat-dialog-actions align="center">
  <button data-tid-ok-button mat-flat-button color="primary" mat-button mat-dialog-close="CONFIRMED" cdkFocusInitial>
    <span class="button-label">OK</span>
  </button>
</div>
